/**
 * @generated SignedSource<<531d82f254886fb892fc283bfdd87aea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditQuery$variables = {
  id: string;
  includeWorkspace: boolean;
  workspaceId: string;
};
export type RoutineEditQuery$data = {
  readonly routine: {
    readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainRoutine_Routine" | "RoutineEditStateProvider_routine">;
  };
  readonly workspace?: {
    readonly topics: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItem_topics">;
    }> | null;
  };
};
export type RoutineEditQuery = {
  response: RoutineEditQuery$data;
  variables: RoutineEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWorkspace"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v11 = [
  (v5/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "orgTopic",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineEditStateProvider_routine"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineEditMainRoutine_Routine"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "condition": "includeWorkspace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoutineEditMainOrgTopicListItem_topics"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoutineEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "ownerTeam",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedRole",
            "kind": "LinkedField",
            "name": "assignedRoles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasks",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 700
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 700
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": "size(minHeight:700,minWidth:700)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentiments",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskCheck",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaskNumberGoals",
                        "kind": "LinkedField",
                        "name": "goals",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lessThan",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "greaterThan",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TaskNumber",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskSectionConnection",
                "kind": "LinkedField",
                "name": "connections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sectionId",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeDisabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "orgCanBeDisabled",
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canBeUnarchived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOrg",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "orgTopic",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canBeConvertedToWorkspaceTemplate",
            "storageKey": null
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v19/*: any*/),
              (v7/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentSchedule",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineDuration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAllDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAdvancedScheduling",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineScheduleDailyWeekday",
                    "kind": "LinkedField",
                    "name": "weekdays",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weekday",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Time",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hour",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minute",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineScheduleTaskImportance",
                        "kind": "LinkedField",
                        "name": "tasks",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "importance",
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "RoutineScheduleDaily",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startWeekday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endWeekday",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weeks",
                    "storageKey": null
                  }
                ],
                "type": "RoutineScheduleWeekly",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "months",
                    "storageKey": null
                  }
                ],
                "type": "RoutineScheduleMonthly",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "descriptionVideos",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canBeConvertedToWeekly",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "includeWorkspace",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3fd766853fd60887e4ccaac901e7495c",
    "id": null,
    "metadata": {},
    "name": "RoutineEditQuery",
    "operationKind": "query",
    "text": "query RoutineEditQuery(\n  $id: ID!\n  $workspaceId: ID!\n  $includeWorkspace: Boolean!\n) {\n  routine(id: $id) {\n    ...RoutineEditStateProvider_routine\n    ...RoutineEditMainRoutine_Routine\n    id\n  }\n  workspace(id: $workspaceId) @include(if: $includeWorkspace) {\n    topics {\n      ...RoutineEditMainOrgTopicListItem_topics\n      id\n    }\n    id\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment RoutineEditAssignedRolesListItem_Routine on Routine {\n  isOrg\n  ownerTeam {\n    id\n  }\n}\n\nfragment RoutineEditContentCard_Routine on Routine {\n  id\n  title\n  type\n  description\n  descriptionFiles {\n    id\n    type\n    name\n    url\n  }\n  descriptionImages {\n    id\n    ...Image_image\n    sizes {\n      height\n      width\n      url\n      id\n    }\n  }\n}\n\nfragment RoutineEditMainOrgTopicListItemSelector_topics on OrgTopic {\n  id\n  name\n  description\n}\n\nfragment RoutineEditMainOrgTopicListItem_topics on OrgTopic {\n  __typename\n  ...RoutineEditMainOrgTopicListItemSelector_topics\n}\n\nfragment RoutineEditMainRoutine_Routine on Routine {\n  id\n  canBeUnarchived\n  isArchived\n  title\n  type\n  isOrg\n  orgTopic {\n    id\n  }\n  canBeConvertedToWorkspaceTemplate\n  ...useIsSaveable_Routine\n  ...RoutineEditContentCard_Routine\n  ...RoutineEditScheduleCard_Routine\n  ...RoutineEditTeamListItem_Routine\n  ...useSaveRoutineEdit_routine\n  ...useRoutineEditDirty_Routine\n  ...RoutineEditAssignedRolesListItem_Routine\n  canBeConvertedToWeekly\n  currentSchedule {\n    __typename\n  }\n}\n\nfragment RoutineEditScheduleCard_Routine on Routine {\n  id\n  title\n  type\n  activeVersion {\n    tasks {\n      id\n      title\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      deadlineDuration\n      isAllDay\n      hasAdvancedScheduling\n      weekdays {\n        weekday\n        startTime {\n          hour\n          minute\n        }\n        tasks {\n          importance\n          taskId\n        }\n      }\n    }\n    ... on RoutineScheduleWeekly {\n      startWeekday\n      endWeekday\n      weeks\n    }\n    ... on RoutineScheduleMonthly {\n      startDay\n      endDay\n      months\n    }\n  }\n}\n\nfragment RoutineEditStateProvider_routine on Routine {\n  id\n  title\n  ownerTeam {\n    id\n    name\n    color\n    icon\n    isPrivate\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  activeVersion {\n    tasks {\n      id\n      title\n      instructions\n      images {\n        id\n        size(minHeight: 700, minWidth: 700) {\n          id\n          url\n          width\n          height\n        }\n      }\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n      ... on TaskNumber {\n        unit\n        goals {\n          section {\n            id\n          }\n          lessThan\n          greaterThan\n        }\n      }\n    }\n    connections {\n      sectionId\n      taskId\n      ordinal\n      orgTopic {\n        id\n        name\n        isPrivate\n      }\n      canBeDisabled\n    }\n    sections {\n      id\n      title\n      ordinal\n      orgCanBeDisabled\n      orgTopic {\n        id\n        name\n        isPrivate\n      }\n      section {\n        id\n        assignedTeam {\n          id\n          name\n          icon\n          color\n          isPrivate\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment RoutineEditTeamListItem_Routine on Routine {\n  title\n  ownerTeam {\n    id\n    name\n    color\n    icon\n    isPrivate\n  }\n}\n\nfragment useIsSaveable_Routine on Routine {\n  isOrg\n  activeVersion {\n    connections {\n      sectionId\n      taskId\n    }\n    id\n  }\n}\n\nfragment useRoutineEditDirty_Routine on Routine {\n  title\n  description\n  ownerTeam {\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  activeVersion {\n    tasks {\n      id\n      title\n      instructions\n      images {\n        id\n        size(minHeight: 700, minWidth: 700) {\n          id\n          url\n          width\n          height\n        }\n      }\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n      ... on TaskNumber {\n        goals {\n          greaterThan\n          lessThan\n          section {\n            id\n          }\n        }\n        unit\n      }\n    }\n    connections {\n      taskId\n      sectionId\n      ordinal\n      canBeDisabled\n      orgTopic {\n        id\n        name\n        isPrivate\n      }\n    }\n    sections {\n      orgCanBeDisabled\n      orgTopic {\n        id\n      }\n      section {\n        id\n        title\n        assignedTeam {\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      deadlineDuration\n      isAllDay\n      weekdays {\n        startTime {\n          hour\n          minute\n        }\n        weekday\n        tasks {\n          importance\n          taskId\n        }\n      }\n    }\n    ... on RoutineScheduleWeekly {\n      startWeekday\n      endWeekday\n      weeks\n    }\n    ... on RoutineScheduleMonthly {\n      months\n      startDay\n      endDay\n    }\n  }\n}\n\nfragment useSaveRoutineEdit_routine on Routine {\n  id\n  title\n  description\n  descriptionFiles {\n    id\n  }\n  descriptionVideos {\n    id\n  }\n  ownerTeam {\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      hasAdvancedScheduling\n    }\n  }\n  activeVersion {\n    tasks {\n      id\n      title\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n    }\n    sections {\n      section {\n        id\n      }\n      id\n    }\n    connections {\n      sectionId\n      taskId\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "104250fff5471505eeb5ee0c67eef6aa";

export default node;
